module.exports = __webpack_public_path__ + "assets/icon-flag-as-inappropriate-selected.cb9eca9a.svg";